// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const lineHeights = {
    100: "1.25",
    200: "1.50",
    300: "1.75",
    400: "2.00",
    500: "2.25",
    600: "2.50",
    700: "2.75",
    800: "3.00",
    900: "3.25",
    1000: "3.50",
    1100: "3.75",
    1200: "4.00",
    1300: "4.25",
    1400: "4.50",
    root: "1.00",
};
module.exports = lineHeights;
//# sourceMappingURL=lineHeights.js.map